export const kontantkort = {
  name: "kontantkort" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M1.6 5.5a.9.9 0 0 1 .9-.9h19a.9.9 0 0 1 .9.9v13a.9.9 0 0 1-.9.9h-19a.9.9 0 0 1-.9-.9v-13Zm1.8.9v6.2h17.2V6.4H3.4Zm0 9.5v1.7h17.2v-1.7H3.4Z" clip-rule="evenodd"/></svg>`,
  keywords: ["kontantkort"],
  category: "finance" as const,
};
